import React, { useEffect, useState, lazy, Suspense } from "react"
import SockJS from "sockjs-client"
import Stomp from "stompjs"
import * as endpoints from "../../../constants/api-constants"
import authService from "../../../services/auth-service"
import NotificationService from "../../../services/notification-service"
import A2hsModal from "../../modals/a2hs-modal/a2hs-modal"
import OnBoardingIOS from "../../modals/onboarding-ios/onboarding-ios"
import RestorePasswordModal from "../../modals/restore-password-modal/restore-password-modal"
import Footer from "../../molecules/footer/footer"
import Header from "../../molecules/header/header"
import ModalChat from "../../modals/modal-chat/modal-chat"
import { sha256 } from 'js-sha256';
import { pushDataLayerEvent } from "../../../utils/metricManagementUtil"
import userSessionStorage from "../../../utils/userSessionStorage"
import "./layout.scss"
const LoadScripts = lazy(() => import("../../atoms/load-scripts/load-scripts"))

const Layout = props => {
  const [isLog, setIsLog] = useState(false)
  const [infoUser, setInfoUser] = useState(null)
  const [popupLogin, setPopupLogin] = useState(false)
  const [commondModal, setCommondModal] = useState(null)
  const [notificationState, setnotificationState] = useState(null)
  const [logStatus, setlogStatus] = useState("waiting")
  const [timeLoadScripts, setTimeLoadScripts] = useState(false)

  const logout = () => {
    setIsLog(false)
    setInfoUser(null)
    localStorage.removeItem("TOKEN_INFO")
    localStorage.removeItem("USER_INFO")
    window.location.reload()
  }

  const getAgeSegment = age => {
    if (age >= 9 && age <= 17) {
      return "sara" //Sara
    } else if (age >= 18 && age <= 24) {
      return "carolina" //carolina
    } else {
      return "juliana" //juliana
    }
  }

  const calculateAge = () => {
    var today = new Date()
    var birthDate = new Date(
      JSON.parse(localStorage.getItem("USER_INFO")).birthdate
    )
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  const eventDataLayerAge = age => {
    try {
      var birthDate = new Date(
        JSON.parse(localStorage.getItem("USER_INFO")).birthdate
      )
      window.dataLayer.push({
        anoNacimiento: birthDate,
        edad: age,
        event: "edadUsuaria",
      })
    } catch (error) {
      console.log("dataLayer error: ", error)
    }
  }

  /**
   * Websocket config
   */
  const webSocketInit = () => {
    try {
      var socket = new SockJS(endpoints.webSocketEndPoint, null, {
        transports: "xhr-polling",
      })

      let stompClient = Stomp.over(socket)
      stompClient.debug = null
      stompClient.connect({}, function(frame) {
        // console.log("Connected: " + frame);
        stompClient.subscribe("/topic/notifications", notification => {
          // If is not showing notification, show notification
          if (notificationState === null) {
            //Validate if is a segmented notification
            if (JSON.parse(notification.body).country) {
              if (
                JSON.parse(notification.body).country ===
                parseInt(process.env.COUNTRY_CODE)
              ) {
                //Validate user notification settings
                if (localStorage.getItem("TOKEN_INFO")) {
                  let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO"))
                    .idToken

                  let config = {
                    headers: {
                      Authorization: tokenId,
                    },
                  }
                  NotificationService.notificationsSettings(config)
                    .then(res => {
                      if (res.status === 200) {
                        if (
                          res.data.filter(
                            elem =>
                              elem.code ===
                              JSON.parse(notification.body).notificationTypeCode
                          )[0].active
                        ) {
                          //Validate user age segment
                          if (JSON.parse(notification.body).segment) {
                            if (
                              getAgeSegment(calculateAge()) ===
                              JSON.parse(notification.body).segment
                            ) {
                              setnotificationState(
                                JSON.parse(notification.body)
                              )
                            }
                          } else {
                            setnotificationState(JSON.parse(notification.body))
                          }
                        }
                      } else {
                        console.log(res)
                      }
                    })
                    .catch(e => console.log(e))
                } else {
                  setnotificationState(JSON.parse(notification.body))
                }
              }
            } else {
              //Validate user notification settings
              if (localStorage.getItem("TOKEN_INFO")) {
                let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO"))
                  .idToken

                let config = {
                  headers: {
                    Authorization: tokenId,
                  },
                }

                NotificationService.notificationsSettings(config)
                  .then(res => {
                    if (res.status === 200) {
                      if (
                        res.data.filter(
                          elem =>
                            elem.code ===
                            JSON.parse(notification.body).notificationTypeCode
                        )[0].active
                      ) {
                        if (JSON.parse(notification.body).segment) {
                          //Validate user age segment
                          if (
                            getAgeSegment(calculateAge()) ===
                            JSON.parse(notification.body).segment
                          ) {
                            setnotificationState(JSON.parse(notification.body))
                          }
                        } else {
                          setnotificationState(JSON.parse(notification.body))
                        }
                      }
                    } else {
                      console.log(res)
                    }
                  })
                  .then(e => console.log(e))
              } else {
                setnotificationState(JSON.parse(notification.body))
              }
            }
          }
        })
      })
    } catch (e) {
      //console.log(e);
    }
  }

  /**
   * a2hs = Add To Home Screen Function
   */
  const a2hs = () => {
    window.addEventListener("beforeinstallprompt", e => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault()
      // Stash the event so it can be triggered later.
      // setdeferredPrompt(e);
      // // Update UI to notify the user they can add to home screen
      // addBtn.style.display = 'block';
      if (
        localStorage.getItem("DENIED_A2HS") === null ||
        localStorage.getItem("DENIED_A2HS") === "false"
      ) {
        setTimeout(() => {
          setCommondModal(
            <A2hsModal
              deferredPrompt={e}
              setCommondModal={setCommondModal}
              // setdeferredPrompt={setdeferredPrompt}
            />
          )
        }, 10000)
      }
    })
  }

  const onBoardingIOS = () => {
    if (
      localStorage.getItem("DENIED_ONBOARDING") === null ||
      localStorage.getItem("DENIED_ONBOARDING") === "false"
    ) {
      setTimeout(() => {
        var body = document.getElementsByTagName("body")[0]
        var html = document.getElementsByTagName("html")[0]
        body.classList.add("overflow-body-hidden")
        html.classList.add("overflow-body-hidden")

        setCommondModal(<OnBoardingIOS setCommondModal={setCommondModal} />)
      }, 15000)
    }
  }
  /*
  const handleLoadArticlesSaved = () => {
    if (localStorage.getItem("TOKEN_INFO") !== null) {
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }
      const listArticles = resultQuery.allContentfulNolArticulos.nodes.filter(
        e => e.node_locale === process.env.LOCALE
      )
      MagazineService.getSavedArticles(config)
        .then(res => {
          if (res.status === 200) {
            let newListArticlesSaved = []
            res.data.map(art => {
              let tempArt = listArticles.filter(a => a.contentful_id === art)[0]
              let tempPayload = {
                id: tempArt.contentful_id,
                titulo: tempArt.metaTitulo,
                descripcion: tempArt.metaDescripcion.metaDescripcion,
                imagen: tempArt.metaImagen,
                categorias: tempArt.categorias,
                slug:
                  tempArt.seccionDelArticulo === "Nuestro Mundo"
                    ? "/magazin/nuestro-mundo/" + tempArt.slug
                    : "/entre-nosotras/" + tempArt.slug,
                imagenCreadorArticulo: tempArt.imagenCreadorArticulo,
                tipoDeArticulo: tempArt.tipoDeArticulo,
                updatedAt: tempArt.fechaDePublicacion,
                nombreCreadorArticulo: tempArt.nombreCreadorArticulo,
                creadorArtculo: tempArt.creadorArtculo,
              }
              newListArticlesSaved.push(tempPayload)
              return null
            })
            localStorage.setItem(
              "SAVED_ARTICLES",
              JSON.stringify(newListArticlesSaved)
            )
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    }
  }
*/

  const pageViewDataLayer = () => {
    let location = ''
    const userSession = new userSessionStorage()
    const userInfo = userSession.getUserInfo()
    if (typeof window !== 'undefined') {
      location = window.location.href
    }
    const encrypt = (string) => {
      if (typeof string === 'string') {
        let hash = sha256.create();
        string = hash.update(string);
        return string.hex()
      } else {
        return undefined
      }
    }
    pushDataLayerEvent({
      event: 'Page_View',
      location: location,
      page: location.split('/').slice(3).join('/'),
      title: props.title || undefined,
      userId: userInfo ? userInfo.userId ? encrypt(userInfo.userId.toString()) : userInfo.usuarioId ? encrypt(userInfo.usuarioId.toString()) : undefined : undefined
    })
  }

  useEffect(() => {
    pageViewDataLayer()
  }, [])
// inicio dataLayer content_consumption

  const dataLayerContentConsumption = (initialTime) => {
    let endTime = ''
    let location = ''
    if (typeof window !== 'undefined') {
      location = window.location.href
      endTime = (window.performance.now() - initialTime) / 1000
    }
    if (endTime > 60 && scrollFlag50 === false) {
      pushDataLayerEvent({
        event: 'content_consumption'
      })
    }

  }

  let scrollFlag50 = true
  const handleScroll = () => {
    const scrollPercentage = (document.documentElement.scrollTop / (document.documentElement.scrollHeight - document.documentElement.clientHeight)) * 100
    if (scrollFlag50 && scrollPercentage >= 50) {
      scrollFlag50 = false
    }
  }

  let initialTime = ''
  useEffect(() => {
    if (typeof window !== 'undefined') {
      initialTime = window.performance.now()
      window.addEventListener('beforeunload', () => { dataLayerContentConsumption(initialTime) })
      window.addEventListener('scroll', () => { handleScroll() })
    }
  }, [])

// fin dataLayer content_consumption
  useEffect(() => {
    // a2hs()
    webSocketInit()

    /*
    if (navigator.onLine) {
      handleLoadArticlesSaved()
    }
*/

    if (!navigator.onLine && localStorage.getItem("TOKEN_INFO") !== null) {
      setIsLog(true)
      setlogStatus("loaded")
    }

    const isIOS = !!navigator.platform && /iPhone/.test(navigator.platform)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

    // if (isIOS && isSafari) onBoardingIOS()

    if (typeof window !== "undefined") {
      //Validate if token is in localStorage to give user session info
      if (localStorage.getItem("TOKEN_INFO") !== null) {
        // var mail = JSON.parse(localStorage.getItem('TOKEN_INFO')).email;

        //Validate if need backend response
        // if (localStorage.getItem('USER_INFO') !== null) {
        //   setInfoUser(JSON.parse(localStorage.getItem('USER_INFO')))
        //   setIsLog(true)

        //   //Validate if need backend response forcePasswordChange
        //   if (JSON.parse(localStorage.getItem('USER_INFO')).forcePasswordChange) {

        //     setCommondModal(<RestorePasswordModal setCommondModal={setCommondModal} />)

        //   }
        // } else {

        var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

        var config = {
          headers: {
            Authorization: tokenId,
          },
        }

        authService
          .sessionInfo(config)
          .then(res => {
            if (res.status === 200) {
              setInfoUser(res.data)
              setIsLog(true)
              setlogStatus("logged")

              if (localStorage.getItem("SHOWED_POPUP") === null) {
                setPopupLogin(true)
                localStorage.setItem("SHOWED_POPUP", true)
              }

              localStorage.setItem("USER_INFO", JSON.stringify(res.data))
              //Validate if need backend response forcePasswordChange
              if (res.data.forcePasswordChange) {
                setCommondModal(
                  <RestorePasswordModal setCommondModal={setCommondModal} />
                )
              }
            } else {
              console.log(res)
            }
          })
          .catch(e => console.log(e))

        // }
      } else {
        setlogStatus("no-logged")
      }
    }
  }, [])

  const dataLayerTimeAndScroll = (event, category, action, label) => {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: event,
        category: category,
        action: action,
        label: label,
      })
    } catch (error) {
      console.log("dataLayerTimeAndScroll página error: ", error)
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      dataLayerTimeAndScroll(
        "Duración página",
        "Duración página",
        "1:30s",
        window.location.href
      )
    }, 90000)
    return () => clearTimeout(timer)
  }, [])

  if (typeof window !== `undefined`) {
    window.onscroll = function() {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop
      var viewScroll =
        document.documentElement.scrollHeight || document.body.scrollHeight
      var scrollPercent =
        (100 * currentScroll) / (viewScroll - window.innerHeight)
      if (scrollPercent > 75) {
        dataLayerTimeAndScroll("Scroll", "Scroll", "75", window.location.href)
        window.onscroll = null
      }
    }
  }

  useEffect(() => {
    if (isLog) {
      eventDataLayerAge(calculateAge())
    }
  }, [isLog])

  useEffect(() => {
    setTimeout(() => {
      setTimeLoadScripts(true)
    }, 4000);
  }, [])

  const haveChat = ["es-CO"]

  return (
    <>
      {!isSSR() && timeLoadScripts && (
        <Suspense fallback={<div/>}>
          <LoadScripts/>
        </Suspense>
      )}
      <Header
        popupLogin={popupLogin}
        mobile={props.mobile}
        modalActive={props.modalActive}
        commondModal={commondModal}
        setCommondModal={setCommondModal}
        isLog={isLog}
        logStatus={logStatus}
        infoUser={infoUser}
        setInfoUser={setInfoUser}
        logout={logout}
        notificationState={notificationState}
        setnotificationState={setnotificationState}
      />
      <div>
        <main>{props.children}</main>
        {/* <Chat /> */}

        {haveChat.includes(process.env.LOCALE) && <ModalChat />}

        {process.env.ENVIRONMENT !== "PDN" && (
          <span className="f-country-watermark">
            {process.env.COUNTRY_NAME + " - " + process.env.ENVIRONMENT}
          </span>
        )}
        {/* <CookieConsent logoUrl={Logo} /> */}
        <Footer setCommondModal={setCommondModal} mobile={props.mobile} />
      </div>
    </>
  )
}
export function isSSR() {
  return typeof window === 'undefined';
  }
export default Layout
